var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkspaceHyperlink = function SvgIconWorkspaceHyperlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_workspace_hyperlink_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.635 7.326a1.313 1.313 0 0 0 1.907.059l2.596-2.596a1.966 1.966 0 0 0 0-2.777L11.972.846a1.966 1.966 0 0 0-2.777 0L6.617 3.459a1.307 1.307 0 0 0 .058 1.902M5.366 6.673a1.32 1.32 0 0 0-1.907-.059L.863 9.21a1.966 1.966 0 0 0 0 2.777l1.167 1.166a1.966 1.966 0 0 0 2.776 0l2.596-2.595a1.313 1.313 0 0 0-.058-1.908M4.453 9.543 9.54 4.456"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_workspace_hyperlink_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconWorkspaceHyperlink;